/* Be Serena 2026 · camada de lançamento Capri: contagens e a abertura da pré-coleção na data. */

/* Lamelas da contagem (o letreiro de partidas da entrada v5): cada dígito é uma casa que vira
   em duas metades. Na primeira vez que a contagem aparece, as casas rodam até o número, como
   a roleta do CAPRI. Com "reduzir movimento", só troca o número. */
(function () {
  var calmo = matchMedia('(prefers-reduced-motion: reduce)').matches;
  var D = 320;
  function casa(ch) {
    // elementos próprios (bs-casa, bs-meia): nenhuma regra de span do tema pega neles
    var c = document.createElement('bs-casa'); c.className = 'bs-lam';
    c.innerHTML = '<bs-meia class="lm-t"><i></i></bs-meia><bs-meia class="lm-b"><i></i></bs-meia><bs-meia class="lm-ft"><i></i></bs-meia><bs-meia class="lm-fb"><i></i></bs-meia>';
    var q = function (x) { return c.querySelector(x); };
    c._p = { t: q('.lm-t i'), b: q('.lm-b i'), ft: q('.lm-ft'), fti: q('.lm-ft i'), fb: q('.lm-fb'), fbi: q('.lm-fb i') };
    por(c, ch); return c;
  }
  function por(c, ch) { var p = c._p; c._ch = ch; p.t.textContent = p.b.textContent = p.fti.textContent = p.fbi.textContent = ch; p.ft.style.transform = 'rotateX(0deg)'; p.fb.style.transform = 'rotateX(90deg)'; }
  function virar(c, novo, d) {
    return new Promise(function (ok) {
      var p = c._p, antigo = c._ch;
      if (antigo === novo) return ok();
      if (calmo || !p.ft.animate) { por(c, novo); return ok(); }
      p.t.textContent = novo; p.fti.textContent = antigo; p.fbi.textContent = novo; p.b.textContent = antigo; c._ch = novo;
      p.ft.animate([{ transform: 'rotateX(0deg)' }, { transform: 'rotateX(-90deg)' }], { duration: d / 2, easing: 'ease-in', fill: 'forwards' }).onfinish = function () {
        p.fb.animate([{ transform: 'rotateX(90deg)' }, { transform: 'rotateX(0deg)' }], { duration: d / 2, easing: 'ease-out', fill: 'forwards' }).onfinish = function () { p.b.textContent = novo; ok(); };
      };
    });
  }
  function rodar(c, alvo, passos, d, atraso) {
    var n = +alvo, seq = [];
    for (var k = passos; k >= 1; k--) seq.push(String((n - k + 100) % 10));
    seq.push(alvo);
    por(c, String((n - passos - 1 + 100) % 10));
    return new Promise(function (ok) {
      setTimeout(function passo() { var x = seq.shift(); if (x === undefined) return ok(); virar(c, x, d).then(passo); }, atraso);
    });
  }
  // a roleta só gira depois que a página terminou de carregar e o processador está livre:
  // o efeito é o mesmo pra quem olha e não disputa com o carregamento da loja
  function depoisDoCarregamento(fn) {
    if (!fn) return;
    var vai = function () { ('requestIdleCallback' in window) ? requestIdleCallback(fn, { timeout: 800 }) : setTimeout(fn, 200); };
    if (document.readyState === 'complete') vai(); else addEventListener('load', vai, { once: true });
  }
  var vistos = new WeakSet(), io = ('IntersectionObserver' in window) ? new IntersectionObserver(function (es) {
    es.forEach(function (e) { if (e.isIntersecting) { io.unobserve(e.target); depoisDoCarregamento(e.target._roleta); } });
  }, { threshold: 0.4 }) : null;
  window.bsLamela = function (b, txt) {
    if (!b._casas) {
      b.textContent = ''; b.classList.add('bs-lamelas'); b._casas = [];
      for (var i = 0; i < txt.length; i++) { var c = casa(txt[i]); b.appendChild(c); b._casas.push(c); }
      b._rodando = false;
      var grupo = b.closest('[data-capri-contagem]');
      if (!calmo && io && grupo && !vistos.has(grupo)) {
        vistos.add(grupo);
        grupo._roleta = function () {
          grupo.querySelectorAll('.bs-lamelas').forEach(function (bb, j) {
            bb._rodando = true;
            Promise.all(bb._casas.map(function (c, i) { return rodar(c, c._ch, 2 + i, 90, j * 110 + i * 60); /* roleta curta: o efeito fica, o custo cai */ }))
              .then(function () { bb._rodando = false; if (bb._pendente) { var t = bb._pendente; bb._pendente = null; window.bsLamela(bb, t); } });
          });
        };
        io.observe(grupo);
      }
      return;
    }
    if (b._rodando) { b._pendente = txt; return; }
    b._casas.forEach(function (c, i) { if (c._ch !== txt[i]) virar(c, txt[i], D); });
  };
})();
(function () {
  var lanc = Date.parse((window.CAPRI && window.CAPRI.lancamento) || '2026-10-08T10:00:00-03:00');
  if (isNaN(lanc)) return;
  var z = function (n) { return String(n).padStart(2, '0'); };

  function partes() {
    var s = Math.max(0, Math.floor((lanc - Date.now()) / 1000));
    return { s: s, d: Math.floor(s / 86400), h: Math.floor((s % 86400) / 3600), m: Math.floor((s % 3600) / 60), seg: s % 60 };
  }
  // contador fora da tela não é redesenhado a cada segundo: atualiza quando volta a aparecer
  var visiveis = new WeakSet(), prontos = new WeakSet();
  var olho = ('IntersectionObserver' in window) ? new IntersectionObserver(function (es) {
    es.forEach(function (e) { if (e.isIntersecting) { visiveis.add(e.target); pintar(); } else visiveis.delete(e.target); });
  }) : null;
  function pintar() {
    var p = partes();
    document.querySelectorAll('[data-capri-contagem]').forEach(function (el) {
      if (olho && !prontos.has(el)) { prontos.add(el); olho.observe(el); }
      else if (olho && !visiveis.has(el)) return;
      var tipo = el.getAttribute('data-capri-contagem');
      if (tipo === 'grade') {
        var set = function (u, v) { var b = el.querySelector('[data-u="' + u + '"]'); if (b) (window.bsLamela ? window.bsLamela(b, z(v)) : (b.textContent = z(v))); };
        set('d', p.d); set('h', p.h); set('m', p.m); set('s', p.seg);
      } else if (tipo === 'curto') {
        el.textContent = p.d > 0 ? p.d + (p.d === 1 ? ' dia' : ' dias') : z(p.h) + 'h' + z(p.m);
      } else {
        el.textContent = 'Faltam ' + p.d + (p.d === 1 ? ' dia' : ' dias') + ' · ' + z(p.h) + ':' + z(p.m) + ':' + z(p.seg);
      }
    });
  }
  // chegou o lançamento: troca os textos marcados com data-depois e esconde as contagens, mesmo que a
  // página tenha vindo do cache da loja montada antes da data (sem esperar o cache renovar)
  var trocou = false;
  function depois() {
    if (trocou) return; trocou = true;
    document.documentElement.classList.add('capri-depois');
    document.querySelectorAll('[data-capri-aparece]').forEach(function (el) { el.hidden = false; });
    document.querySelectorAll('[data-depois]').forEach(function (el) {
      var novo = el.getAttribute('data-depois'); if (!novo) return;
      // troca só o texto, mantendo ícones e pontinhos que estão dentro
      var t = Array.prototype.find.call(el.childNodes, function (n) { return n.nodeType === 3 && n.nodeValue.trim(); });
      if (t) t.nodeValue = novo; else el.insertBefore(document.createTextNode(novo), el.querySelector('b,i') ? null : el.firstChild);
      var b = el.querySelector('b[data-capri-contagem]'); if (b) b.remove();
    });
  }
  pintar(); if (partes().s === 0) depois();
  setInterval(function () { pintar(); if (partes().s === 0) depois(); }, 1000);
})();

/* Pix e parcelas da página de produto: refaz a conta quando a variante troca o preço. */
(function () {
  var caixa = document.querySelector('[data-bs-pagamento]');
  var preco = document.querySelector('.product-details-page #ProductPrice');
  if (!caixa || !preco) return;
  var pix = +caixa.dataset.pix || 0, parc = +caixa.dataset.parcelas || 1;
  var fmt = new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' });
  function centavos(txt) { var n = (txt || '').replace(/[^0-9,]/g, '').replace(',', '.'); return Math.round(parseFloat(n) * 100); }
  function refazer() {
    var c = centavos(document.querySelector('.product-details-page #ProductPrice').textContent);
    if (!c) return;
    var bp = caixa.querySelector('[data-bs-pix]'), bc = caixa.querySelector('[data-bs-parc]');
    // só escreve quando muda: escrever sempre dispararia o próprio observador
    var tp = fmt.format(Math.floor(c * (100 - pix) / 100) / 100), tc = fmt.format(Math.floor(c / parc) / 100);
    if (bp && bp.textContent !== tp) bp.textContent = tp;
    if (bc && bc.textContent !== tc) bc.textContent = tc;
  }
  new MutationObserver(refazer).observe(document.querySelector('.product-details-page') || document.body, { subtree: true, childList: true, characterData: true });
})();

/* Cards sobem ao entrar na tela, em cascata curta. Sem IntersectionObserver, ficam como estão. */
(function () {
  if (!('IntersectionObserver' in window) || matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  var io = new IntersectionObserver(function (es) {
    es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('bs-visto'); io.unobserve(e.target); } });
  }, { rootMargin: '0px 0px -8% 0px' });
  function preparar(raiz) {
    (raiz || document).querySelectorAll('.single-product-wrap:not(.bs-sobe)').forEach(function (el) {
      var irmaos = el.parentElement && el.parentElement.parentElement ? el.parentElement.parentElement.children : [];
      var i = Array.prototype.indexOf.call(irmaos, el.parentElement);
      el.style.setProperty('--bs-atraso', (Math.max(0, i) % 5) * 70 + 'ms');
      el.classList.add('bs-sobe'); io.observe(el);
    });
  }
  // só os cards da carga inicial: os que chegam por AJAX (filtro, rolagem infinita) entram direto, sem risco de ficar invisível
  preparar();
})();



/* Entradas: títulos de seção, foto e texto da Be Serena, aviso e newsletter sobem ao aparecer,
   e a frase da marca entra palavra por palavra. Uma vez só; sem IntersectionObserver ou com
   "reduzir movimento", tudo fica como está. */
(function () {
  if (!('IntersectionObserver' in window) || matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  var frase = document.querySelector('.bs-sobre-frase');
  if (frase && !frase.dataset.bsDividida) {
    var palavras = frase.textContent.trim().split(/\s+/);
    frase.textContent = '';
    palavras.forEach(function (p, i) {
      var s = document.createElement('span'); s.className = 'bs-palavra'; s.style.setProperty('--i', i); s.textContent = p;
      frase.appendChild(s); if (i < palavras.length - 1) frase.appendChild(document.createTextNode(' '));
    });
    frase.dataset.bsDividida = '1'; frase.classList.add('bs-anima');
  }
  var alvos = [];
  document.querySelectorAll('.section-capture, .bs-sobre-rotulo, .bs-sobre-valores, .bs-sobre-insta, .bs-sobre-moldura, .capri-aviso-barra, .newsletter-bg').forEach(function (el, i) {
    el.classList.add('bs-entra'); alvos.push(el);
  });
  document.querySelectorAll('.bs-sobre-valores, .bs-sobre-insta').forEach(function (el, i) { el.style.setProperty('--bs-atraso', (200 + i * 140) + 'ms'); });
  if (frase) alvos.push(frase);
  var io = new IntersectionObserver(function (es) {
    es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('bs-visto'); io.unobserve(e.target); } });
  }, { rootMargin: '0px 0px -6% 0px' });
  alvos.forEach(function (el) { io.observe(el); });
})();
